export default __webpack_public_path__ + "static/db-views-ea412e26be7e2b6a6f98c982f5dade91.png";